const styles = () => ({
  default: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'opacity 1.25s',
  },

  root: {
    color: '#fff',
    padding: '0 16px',
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    minHeight: 55,
    boxShadow:
      '0 4px 5px 0 rgba(71, 110, 164, 0.15), 0 1px 2px 0 rgba(59, 78, 125, 0.22)',
  },

  message: {
    display: 'flex',
    alignItems: 'center',
  },

  transitionIn: {
    visibility: 'visible',
    opacity: 1,
  },
});

export default styles;
